import React from "react";
import { graphql } from "gatsby";
import { Pagination } from "../../Pagination";
import { PostListItem } from "../PostListItem";
import "./PostList.scss";
import { PostListNavigation } from "../PostListNavigation";

export const PostList = ({
  posts,
  pageContext,
  pathPrefix,
  categoryFilter,
}) => {
  return (
    <section className="project-list layout">
      <div className="project-list__wrapper">
        <h2 className="heading">Our News Posts</h2>
        {/* <PostListNavigation categoryFilter={categoryFilter} postSlug="/news/" /> */}
        <div className="project-list-grid">
          {Object.keys(posts).length > 0 &&
            posts?.map((post, index) => {
              return <PostListItem key={index} data={post.node} />;
            })}
        </div>
        <Pagination pageContext={pageContext} pathPrefix={pathPrefix} />
      </div>
    </section>
  );
};

export const pageQuery = graphql`
  fragment PostListFields on wordpress__POST {
    id
    categories {
      id
      name
      slug
      path
    }
    title
    excerpt
    date
    slug
    path
    featured_media {
      localFile {
        childImageSharp {
          fluid(maxWidth: 670, quality: 80) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  }
`;
